import { useMemo } from "react";
import { encodeQr, qrPath } from "./qrEncoder";

/**
 * A QR code drawn as one SVG path, black on white with the standard 4-module quiet zone in every theme (scanners need
 * the contrast). Encoded in the browser (qrEncoder.ts): the text (an authenticator secret) is never sent anywhere.
 */
export function QrCode({ text, label, size = 240 }: { text: string; label: string; size?: number }) {
  const matrix = useMemo(() => encodeQr(text, "M"), [text]);
  const dim = matrix.size + 8;
  return (
    <svg className="qr-code" role="img" aria-label={label} viewBox={`0 0 ${dim} ${dim}`} width={size} height={size} shapeRendering="crispEdges" data-testid="qr-code">
      <rect width={dim} height={dim} fill="#ffffff" />
      <path d={qrPath(matrix, 4)} fill="#000000" />
    </svg>
  );
}
